import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageCaptureComponent } from './components/image-capture/image-capture.component';
import {WebcamModule} from 'ngx-webcam';
import { AttachFileComponent } from './components/attach-file/attach-file.component';
import { MatButtonModule, MatCardModule, MatProgressSpinnerModule, MatInputModule, MatIconModule, MatMenuModule, MatGridListModule, MatCheckboxModule, MatToolbarModule, MatFormFieldModule, MatSidenavModule, MatListModule, MatTableModule, MatSelectModule, MatDialogModule, MatTooltipModule, MatTabsModule, MatProgressBarModule, MatDatepickerModule, MatNativeDateModule, MatAutocompleteModule } from '@angular/material';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { DropFileComponent } from './components/drop-file/drop-file.component';
import { FileDropModule } from '../../directives/file-drop/file-drop.module';
import { ImagePreviewComponent } from './components/image-preview/image-preview.component';
import { MessageBarComponent } from './components/message-bar/message-bar.component';
import { ReferenceComponent } from './components/reference/reference.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ImageBrowserComponent } from './components/image-browser/image-browser.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { HorizontalBarChartComponent } from './components/horizontal-bar-chart/horizontal-bar-chart.component';
import { StateReferenceComponent } from './components/state-reference/state-reference.component';

@NgModule({
  declarations: [ImageCaptureComponent, AttachFileComponent, DropFileComponent, ImagePreviewComponent, MessageBarComponent, ReferenceComponent, ImageBrowserComponent, HorizontalBarChartComponent, StateReferenceComponent],
  entryComponents:[DropFileComponent],
  imports: [
    CommonModule,
    InfiniteScrollModule,
    WebcamModule,
    MatButtonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatIconModule,
    MatMenuModule,
    MatGridListModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatIconModule,
    MatSidenavModule,
    MatListModule,
    MatTableModule,
    MatSelectModule,
    MatDialogModule,
    MatTooltipModule,
    MatTabsModule,
    MatProgressBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaterialTimepickerModule,
    NgxMatSelectSearchModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    FlexLayoutModule,
    TranslateModule,
    FileDropModule,
    ReactiveFormsModule,
    MatAutocompleteModule
  ],
  exports:[
    ImageCaptureComponent,
    AttachFileComponent,
    ImagePreviewComponent,
    MessageBarComponent,
    ReferenceComponent,
    ImageBrowserComponent    
  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class SharedModule { }
